'use strict';

var React = require('react');

var SvgAirplaneIcon = function SvgAirplaneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.259 12.25c1.35 0 2.192-1.465 1.512-2.632l-.294-.504a2.75 2.75 0 0 0-2.376-1.364h-1.612l-1.368-2.21a3.25 3.25 0 0 0-2.764-1.54h-.607a.75.75 0 0 0-.742.856l.413 2.894h-.133l-.205-.443a2.25 2.25 0 0 0-2.043-1.307h-1.29a.75.75 0 0 0-.734.905l1 4.75a.75.75 0 0 0 .734.595h2.671l-.413 2.894a.75.75 0 0 0 .742.856h.607a3.25 3.25 0 0 0 2.764-1.54l1.368-2.21h2.77Zm-4.534-4.5-.88-1.421a1.75 1.75 0 0 0-1.227-.81l.318 2.231h1.79Zm-2.726 1.5h-1.191a.75.75 0 0 1-.681-.436l-.406-.878a.75.75 0 0 0-.68-.436h-.367l.685 3.25h2.927a.75.75 0 0 1 .742.856l-.41 2.875a1.75 1.75 0 0 0 1.227-.81l1.589-2.566a.75.75 0 0 1 .637-.355h3.188a.25.25 0 0 0 .216-.376l-.294-.504a1.25 1.25 0 0 0-1.08-.62h-6.102Z"
  }));
};
SvgAirplaneIcon.displayName = "AirplaneIcon";

exports.SvgAirplaneIcon = SvgAirplaneIcon;
